import React, { useMemo, useState } from "react";
import "./OpenPositions.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { HiOutlineLocationMarker, HiOutlineClock, HiOutlineExternalLink } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useCareersSection } from "../../../../context/CareersPageContext";
import {
  getPositionFiltersFromSection,
  getPositionsFromSection,
} from "../../../../services/contentApi";
import { stripRichText } from "../../../../utils/richText";

const VIEW_ALL = "View all";

const OpenPositions = () => {
  const { section, loading } = useCareersSection("open-positions");
  const [active, setActive] = useState(VIEW_ALL);

  const positions = useMemo(
    () => (section?.fields ? getPositionsFromSection(section) : []),
    [section]
  );

  const apiFilters = useMemo(
    () => (section?.fields ? getPositionFiltersFromSection(section) : []),
    [section]
  );

  const filters = useMemo(() => {
    const list = [VIEW_ALL, ...apiFilters.filter((f) => f !== VIEW_ALL)];
    return [...new Set(list)];
  }, [apiFilters]);

  const filtered = useMemo(() => {
    if (active === VIEW_ALL) return positions;
    const activeLabel = stripRichText(active);
    return positions.filter(
      (job) => stripRichText(job.category) === activeLabel
    );
  }, [positions, active]);

  const headerTitle = section?.fields?.header_title ?? "";
  const headerDescription = section?.fields?.header_description ?? "";

  if (loading || !section?.fields) return null;

  return (
    <section className="jobs">
      <div className="jobs__container">
        <div className="jobs__header">
          {headerTitle ? <CmsText content={headerTitle} as="h2" /> : null}
          {headerDescription ? (
            <RichTextContent content={headerDescription} />
          ) : null}
        </div>

        {filters.length > 1 ? (
          <div className="jobs__filters-wrapper">
            <div className="jobs__filters">
              {filters.map((f) => (
                <button
                  key={f}
                  type="button"
                  className={active === f ? "active" : ""}
                  onClick={() => setActive(f)}
                >
                  <CmsText content={f} as="span" />
                </button>
              ))}
            </div>
          </div>
        ) : null}

        {filtered.length > 0 ? (
          <div className="jobs__list">
            {filtered.map((job) => (
              <Link
                to={`/position/${job.slug}`}
                className="job-card"
                key={job.slug}
              >
                <div className="job-left">
                  {job.category ? (
                    <CmsText content={job.category} as="span" className="job-category" />
                  ) : null}
                  {job.title ? <CmsText content={job.title} as="h3" /> : null}

                  <div className="job-meta">
                    {job.location ? (
                      <span className="meta-item">
                        <HiOutlineLocationMarker className="icon" />
                        <CmsText content={job.location} as="span" />
                      </span>
                    ) : null}

                    {job.type ? (
                      <span className="meta-item">
                        <HiOutlineClock className="icon" />
                        <CmsText content={job.type} as="span" />
                      </span>
                    ) : null}
                  </div>
                </div>

                <div className="job-right">
                  <span>
                    View job <HiOutlineExternalLink className="job-right__arrow" aria-hidden />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default OpenPositions;
